/* istanbul ignore file */

/*FILE IS NOT FUNCTIONING AS EXPECTED! NEED TO BE FIXED*/
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Inline } from 'components/base/Text';
import { getColor } from 'common/constants/_colors';
import { SPACES, SIZES } from 'common/constants/sizes';

const InlineEdit = ({
  callback,
  validate = () => Promise.resolve(),
  value,
  placeholder,
  size = 'medium',
  textColor,
  dataCy,
  readonly
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [newValue, setNewValue] = useState(value);
  const [error, setError] = useState(false);
  const inputRef = useRef();

  const errorStyle = {
    border: `1px solid ${getColor('torchRed')}`
  };

  const spacing = {
    padding: SPACES['x-small']
  };

  const editableInput = {
    outline: 'none',
    border: `1px solid ${getColor('botticelli')}`,
    borderRadius: `unset`,
    fontSize: SIZES[size]
  };

  const editableText = {
    border: '1px solid transparent',
    borderRadius: 'unset',
    fontSize: SIZES[size]
  };

  useEffect(() => {
    if (inputRef && inputRef.current && isEdit) {
      inputRef.current.focus();
    }
  }, [isEdit]);

  const handleKeyDown = event => {
    const { key } = event;
    const keys = ['Escape', 'Tab', 'Enter'];

    if (keys.indexOf(key) > -1) {
      handleChange();
    }
  };

  const handleChange = async () => {
    if (typeof validate === 'function') {
      try {
        await validate(newValue);
        setIsEdit(false);
        callback(newValue);
      } catch (e) {
        setError(e);
      }
    } else {
      setIsEdit(false);
      callback(newValue);
    }
  };

  return (
    <section>
      {isEdit ? (
        <>
          <input
            ref={inputRef}
            placeholder={placeholder}
            value={newValue}
            data-cy={dataCy}
            onChange={e => {
              setNewValue(e.target.value);
              setError(false);
            }}
            onBlur={() => {
              handleChange();
            }}
            onKeyDown={e => handleKeyDown(e)}
            style={
              error
                ? { ...spacing, ...editableInput, ...errorStyle }
                : { ...spacing, ...editableInput }
            }
          />
          {error && (
            <Inline pl={SPACES['x-small']} color='torchRed'>
              {error}
            </Inline>
          )}
        </>
      ) : (
        <div
          {...(!readonly && { onClick: () => setIsEdit(true) })}
          data-cy={dataCy}
          style={{
            ...spacing,
            ...editableText,
            ...(textColor && {
              color: getColor(textColor)
            })
          }}
        >
          {newValue || placeholder || ''}
        </div>
      )}
    </section>
  );
};

InlineEdit.propTypes = {
  callback: PropTypes.func,
  validate: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.string
};

export default InlineEdit;
